import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Flex,
  HeaderCenterType,
  Image,
  theme,
  Typography,
  message,
} from '@goalsetter/ant-design-ui';

import i18n from '@/localization/i18n';
import Images from '@/assets/img/Images';
import {
  imageStyles,
  titleStyle,
  descriptionStyle,
  contentStyle,
} from './has-no-seats-error/styles';
import { setHeaderProps } from '@/redux/slices/layout';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/types/redux';
import { useUserSignUp } from '@/api';
import { LocalStorageManager, LOCAL_STORAGE } from '@/utils/localStorage';

const { useToken } = theme;
const { Title, Text } = Typography;

const ExpiredTokenErrorPage = () => {
  const { token } = useToken();
  const dispatch = useDispatch<AppDispatch>();
  const { resendActivationLink } = useUserSignUp();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    dispatch(
      setHeaderProps({
        headerCenterProps: {
          type: HeaderCenterType.IMAGE,
          imageSource: Images.LOGO,
          alt: 'Moneylingo logo',
        },
      }),
    );
  }, [dispatch]);

  const getNewLink = useCallback(async () => {
    setLoading(true);
    try {
      const teacherToken = LocalStorageManager.get(LOCAL_STORAGE.TEACHER_TOKEN);
      await resendActivationLink(teacherToken ? { token: teacherToken } : {});
      messageApi.success(i18n.t('expiredTokenError.successMessage'));
    } catch {
      messageApi.error(i18n.t('expiredTokenError.errorMessage'));
    } finally {
      setLoading(false);
    }
  }, [resendActivationLink, messageApi]);

  return (
    <>
      {contextHolder}
      <Flex
        gap={24}
        vertical
        align="center"
        style={contentStyle}
      >
        <Image
          src={Images.FAILED}
          alt="expired-token-error"
          style={imageStyles}
          aria-hidden="true"
        />
        <Title
          level={3}
          style={titleStyle}
          color={token.colorTextLightSolid}
        >
          {i18n.t('expiredTokenError.title')}
        </Title>
        <Text
          style={descriptionStyle}
          color={token.colorTextLightSolid}
        >
          {i18n.t('expiredTokenError.subtitle')}
        </Text>
      </Flex>
      <Button
        block
        type="gameSecondary"
        htmlType="button"
        shape="round"
        size="large"
        loading={loading}
        onClick={getNewLink}
      >
        {i18n.t('expiredTokenError.button')}
      </Button>
    </>
  );
};

export default ExpiredTokenErrorPage;
